import {UseListParamsReturn} from '../../../hooks/listParams';
import {useListSearchParams} from '../../../hooks/useListSearchParams';

export function useNotificationsListSearchParams(): UseListParamsReturn {
    return useListSearchParams();
}
